module.exports = __webpack_public_path__ + "img/ef2.96f9d1d3.jpg";